import type { SmsTemplatesModalUICopy } from './types';

export const SMS_TEMPLATES_MODAL: SmsTemplatesModalUICopy = {
  description:
    'This template can be used in Knowledge base or Rules to send SMS to your callers during a conversation.',
  add: {
    title: 'Add SMS template',
    button: {
      confirm: 'Add',
    },
  },
  edit: {
    title: 'Edit SMS template',
    button: {
      confirm: 'Save',
    },
  },
  view: {
    title: 'View SMS',
    button: {
      confirm: 'Close',
    },
  },
  form: {
    title: {
      label: 'Title',
      placeholder: 'Title',
      helpText: 'The name of the SMS template',
      duplicateError: 'SMS template already exists',
    },
    smsBody: {
      label: 'SMS body',
      placeholder: 'Type in',
      helpText: 'The actual text a caller will receive',
    },
    phoneNumber: {
      label: 'Phone number',
      helpText: 'The phone number from which the SMS will be sent from',
    },
  },
};
